if (!customElements.get('ff-buy-buttons')) {
  customElements.define(
    'ff-buy-buttons',
    class FfBuyButtons extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
      }

      connectedCallback() {
        this.lensadvisorContainer = this.querySelector('.ff-buy-buttons__lensadvisor');
        this.isPrescription = this.dataset.prescription === 'true';
        this.btnClass = this.isPrescription
          ? this.dataset.submitClass
          : this.dataset.extraClass;
        this.textClass = this.isPrescription
          ? this.dataset.submitTextClass
          : this.dataset.extraTextClass;

        if (this.lensadvisorContainer) {
          this.setupLensAdvisorBtn();
          this.observeLensAdvisorBtn();
        }

        this.setupVariantListener();
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        if (this.boundVariantHandler) {
          document.removeEventListener('variant-selector:change', this.boundVariantHandler);
        }
      }

      setupLensAdvisorBtn() {
        const laBtn = this.querySelector('#la-select-lenses-btn');
        if (!laBtn) return;

        if (laBtn.parentElement !== this.lensadvisorContainer) {
          this.lensadvisorContainer.appendChild(laBtn);
        }

        if (this.btnClass && !laBtn.classList.contains(this.btnClass)) {
          laBtn.classList.add(this.btnClass);
        }

        if (this.textClass && !laBtn.classList.contains(this.textClass)) {
          laBtn.classList.add(this.textClass);
        }
      }

      setupVariantListener() {
        this.boundVariantHandler = (e) => {
          const { productId, variant } = e.detail;
          if (this.dataset.productId !== productId) return;
          this.updateSubmitButton(variant);
        };
        document.addEventListener('variant-selector:change', this.boundVariantHandler);
      }

      updateSubmitButton(variant) {
        const submitBtn = this.querySelector('[type="submit"]');
        const variantInput = this.querySelector('[name="id"]');
        const buttonText = submitBtn?.querySelector('.ff-button-text');
        if (!submitBtn) return;

        const isAvailable = variant && variant.available;

        if (variantInput) {
          variantInput.disabled = !isAvailable;
          if (variant) variantInput.value = variant.id;
        }

        submitBtn.disabled = !isAvailable;
        submitBtn.classList.toggle('ff-button-disabled', !isAvailable);
        submitBtn.classList.toggle('ff-button-container--unavailable', !isAvailable);

        if (buttonText) {
          const textElement = buttonText.querySelector('.ff-snippet-text') || buttonText;
          if (!variant) {
            textElement.textContent = this.dataset.unavailableText;
          } else if (!variant.available) {
            textElement.textContent = this.dataset.soldOutText;
          } else {
            textElement.textContent = this.dataset.addToCartText;
          }
        }
      }

      observeLensAdvisorBtn() {
        this.observer = new MutationObserver(() => {
          this.setupLensAdvisorBtn();
        });

        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
  );
}
